import { render, staticRenderFns } from "./PaDeptTrend.vue?vue&type=template&id=1f49aa1e&scoped=true"
import script from "./PaDeptTrend.vue?vue&type=script&lang=js"
export * from "./PaDeptTrend.vue?vue&type=script&lang=js"
import style0 from "./PaDeptTrend.vue?vue&type=style&index=0&id=1f49aa1e&prod&lang=css"
import style1 from "./PaDeptTrend.vue?vue&type=style&index=1&id=1f49aa1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f49aa1e",
  null
  
)

export default component.exports